var map = {
	"./bg1.jpg": 1058,
	"./bg2.jpg": 1059,
	"./bg3.jpg": 1060,
	"./bg4.jpg": 1061,
	"./bg5.jpg": 1062,
	"./bg6.jpg": 1063,
	"./bg7.jpg": 1064
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1927;


//////////////////
// WEBPACK FOOTER
// ./src/assets/auth/img/bg ^\.\/.*$
// module id = 1927
// module chunks = 17